// eslint-disable-next-line no-restricted-imports
import { useAppButton } from "@1js/acui-button/lib/Next";

import { useRibbonControlLabel } from "./useRibbonControlLabel";
import { useRibbonButtonVariant } from "./useRibbonButtonVariant";
import { useCommonRibbonButtonLabelClassNames } from "../../next/commonRibbonButtonStyles.styles";
import type {
  RibbonButtonProps,
  RibbonButtonState,
} from "./RibbonButton.types";

export const useRibbonButton = (
  props: RibbonButtonProps,
  ref: React.Ref<HTMLButtonElement>
): RibbonButtonState => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const appButtonState = useAppButton(
    {
      ...props,
      children: useRibbonControlLabel(
        label,
        size,
        onRenderText,
        useCommonRibbonButtonLabelClassNames(size)
      ),
      dataAutomationType: dataAutomationType ?? "RibbonButton",
    },
    ref
  );

  useRibbonButtonVariant(
    appButtonState as RibbonButtonState,
    variant as RibbonButtonState["variant"],
    variantId as RibbonButtonState["variantId"]
  );

  return appButtonState;
};
